module.exports = __webpack_public_path__ + "img/something-went-wrong.8032c95a.svg";